/**
 * ProjectTeamMemberService
 * Service for ProjectTeamMember entity operations
 * Route: api/project-team-members
 * Controller: ProjectTeamMemberController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * ProjectTeamMemberService
 * Handles project team member CRUD operations
 * Maps to /api/project-team-members endpoint
 */
export class ProjectTeamMemberService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ProjectTeamMemberService.DEFAULT_SERVICE_PATH,
            basePath: ProjectTeamMemberService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
ProjectTeamMemberService.DEFAULT_SERVICE_PATH = 'projects';
ProjectTeamMemberService.BASE_PATH = 'api/project-team-members';
//# sourceMappingURL=ProjectTeamMemberService.js.map